module.exports = __webpack_public_path__ + "static/quartier_B-3aec8a8a49d2f027e1bf4a82d98f6fc8.png";